import { requests } from '../../api/api.service';
import {BRAND_ACCESS_RIGHT_URL} from '../../utils/Endpoints';
import {BaseModel} from '../../model/shared/BaseModel';
import {BrandAclRequest, BrandAclResponse} from './types';

export const BrandAccessRightsService = {
    getBrandAclList: (params: any): Promise<BaseModel<BrandAclResponse>> =>
        requests.get(`${BRAND_ACCESS_RIGHT_URL}`, params),
    editBrandAcl: (id: number, body: BrandAclRequest): Promise<BrandAclResponse> =>
        requests.put(`${BRAND_ACCESS_RIGHT_URL}/${id}`, body),
    createBrandAcl: (body: BrandAclRequest): Promise<BrandAclResponse> =>
        requests.post(BRAND_ACCESS_RIGHT_URL, body),
};
